import React, { Component } from "react";
import { createNotification } from "../helpers/Notification";
import Loader from "../common/Loader";
import { DropDown } from "../common";
import SimpleReactValidator from "simple-react-validator";
import MasterDataService from "../services/MasterDataService";
import ConfirmBox from '../common/ConfirmBox';
import { Link } from "react-router-dom";
export default class AddDrawingType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      organization: "",
      status: "Active",
      loader: false,
      drawingTypeId: null,
      headingText: "Add",
      button: "Save",
      isShowConfirmBox:false
    };
    this.validator = new SimpleReactValidator();
  }

  componentDidMount = () => {
    const { match } = this.props;
    if (match.path === "/drawingtype/:drawingTypeId" && match.params.drawingTypeId !== null) {
      this.setState({
        drawingTypeId: match.params.drawingTypeId,
        headingText: "Edit",
        button: "Update",
      });
      this.getDrawingTypeById(match.params.drawingTypeId);
    }
  };

  getDrawingTypeById = (drawingTypeId) => {
    if (drawingTypeId !== "") {
      MasterDataService.getDrawingTypesById(drawingTypeId)
        .then((response) => {
          if (response.status) {
            let resData = response.data.data;
            this.setState({
              name: resData.title,
              organization: resData.organization,
              status: resData.status == "ACTIVE" ? "Active" : "Inactive",
            });
          }
          console.log({ response: response });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            createNotification("error", "Your login session has been expired!");
            localStorage.clear();
            this.props.history.push("/login");
          } else {
            createNotification("error", error.response.data.error.message);
          }
          console.log({ resetPasswordError: error });
        });
    }
  };

  handleResetState = () => {
    this.setState({
      name: "",
      organization: "",
      status: "Active",
      drawingTypeId: null,
      headingText: "Add",
      button: "Save",
    });
  };

  handleOnChange = (event) => {
    if (event.target.name === "name") {
      this.setState({ name: event.target.value });
    } else if (event.target.name === "status") {
      this.setState({ status: event.target.value });
    }
  };

  onStatusChange = (e) => {
    const { match } = this.props;
    if (this.state.status === "Active" && match.path !== "/adddrawingtype") {
      this.setState({ isShowConfirmBox: true })
    }else{
      this.setState({ status: e.target.value });
    } 
  };

  handleConfirmModal = (isYes) => {
    if(isYes){
      this.setState({ status: "Inactive",isShowConfirmBox: !this.state.isShowConfirmBox  });
    }else{
      this.setState({ status: "Active",isShowConfirmBox: !this.state.isShowConfirmBox  });
    }
  }

  handleSaveDrawingType = () => {
    const { name, organization, status, drawingTypeId } = this.state;
    const { match } = this.props;
    if (this.validator.allValid()) {
        this.setState({ loader: true });
        let nm=name.trim();
        const data = { title:nm, organization: Number(organization), status };
        if (match.path === "/drawingtype/:drawingTypeId" && drawingTypeId !== null) {
          MasterDataService.updateDrawingTypeById(drawingTypeId, data)
            .then((response) => {
              console.log({drawingResponse:response})
              if (response.status === 200) {
                createNotification("success", "Drawing Type updated successfully!");
                this.handleResetState();
                this.setState({ loader: false });
                this.props.history.push("/drawingtype");
              }
              console.log({ response });
            })
            .catch((error) => {
              if (error.response.status === 401) {
                createNotification(
                  "error",
                  "Your login session has been expired!"
                );
                localStorage.clear();
                this.props.history.push("/login");
                this.setState({ loader: false });
              } else {
                createNotification("error", error.response.data.error.message);
                this.setState({ loader: false });
              }
              console.log({ resetPasswordError: error });
            });
        } else {
          MasterDataService.addDrawingType(data)
            .then((response) => {
              if (response.status === 200) {
                createNotification("success", "Drawing Type is added successfully!");
                this.handleResetState();
                this.setState({ loader: false });
                this.props.history.push("/drawingtype");
              }
              console.log({ response });
            })
            .catch((error) => {
              if (error.response.status === 401) {
                createNotification(
                  "error",
                  "Your login session has been expired!"
                );
                localStorage.clear();
                this.props.history.push("/login");
                this.setState({ loader: false });
              } else {
                createNotification("error", error.response.data.error.message);
                this.setState({ loader: false });
              }
              console.log({ resetPasswordError: error });
            });
        }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { loader,isShowConfirmBox } = this.state;
    
    return (
      <div>
        {loader ? (
          <Loader />
        ) : (
          <div className="main-content addUser-form">
            <div className="page-content">
              <div className="container-fluid">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <ol className="breadcrumb m-0">
                    <Link to={`/#`}><li className="breadcrumb-item">Home</li></Link>
                    &nbsp; / &nbsp;
                    <Link to={`/drawingtype`}><li className="breadcrumb-item">Drawing Type</li></Link>
                    &nbsp; / &nbsp;
                    {this.props.match.path == `/adddrawingtype` ?
                      <Link to={`/adddrawingtype`}><li className="breadcrumb-item">Add</li></Link>
                    :this.props.match.path == `/drawingtype/:drawingTypeId` ? 
                      <Link to={`/drawingtype/${this.props.match.params.drawingTypeId}`}><li className="breadcrumb-item">Edit</li></Link>
                    :''}
                  </ol>
                </div>
                <h4 className="mb-0">{this.state.headingText} Drawing Type</h4>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card card-block">
                      <div className="card-body">
                        <div className="wizard clearfix">
                          <div className="content clearfix">
                            <form className="form-project ">
                              <div className="row">
                                <div className="col-md-4 col-sm-12">
                                  <div className="mb-3">
                                    <label
                                      className="form-label"
                                      for="validationCustom01"
                                    >
                                      Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="validationCustom01"
                                      name="name"
                                      onChange={this.handleOnChange}
                                      placeholder="Name"
                                      required=""
                                      value={this.state.name}
                                    />
                                    {this.validator.message(
                                      "name",
                                      this.state.name,
                                      "required|max:70",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-4 col-sm-12">
                                  <div className="mb-3">
                                    <label
                                      className="form-label"
                                      for="validationCustom01"
                                    >
                                      Status
                                    </label>
                                    <DropDown
                                      name="status"
                                      options={[
                                        { lable: "Active", value: "Active" },
                                        {
                                          lable: "Inactive",
                                          value: "Inactive",
                                        },
                                      ]}
                                      onChange={(e) => this.onStatusChange(e)}
                                      defaultSelected={this.state.status}
                                      lable=""
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row"></div>
                            </form>
                          </div>
                          <div className="actions clearfix">
                            <button
                              type="button"
                              className="btn btn-primary waves-effect waves-light"
                              onClick={() => this.handleSaveDrawingType()}
                            >
                              <i className="uil uil-edit"></i>{" "}
                              {this.state.button}
                            </button>
                          </div>
                          <ConfirmBox
                            openModal={isShowConfirmBox}
                            confirmMsg="This entity might being used in one or more projects. Inactivating will remove it from there. Do you still want to continue?"
                            handleConfirmModal={this.handleConfirmModal}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
